import { render, staticRenderFns } from "./DisLike.vue?vue&type=template&id=87c191ca"
import script from "./DisLike.vue?vue&type=script&lang=js"
export * from "./DisLike.vue?vue&type=script&lang=js"
import style0 from "./DisLike.vue?vue&type=style&index=0&id=87c191ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports